import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBox } from '_components';
import styles from './Common.module.css'

class PatientCareCenterNoteChargesGroupRow extends React.Component {


    handleClick(selected) {
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    handleChange() {
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    render() {
        return (
            <div className={styles.row}>
                <span className={styles.col1}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity={this.props.table}
                        entityKeyColumn={this.props.prefix + 'NO'}
                        entityKeyValue={this.props.id}
                        field={this.props.prefix + 'ISGROUP'}
                        label={this.props.activity}
                        className={styles.group_checkbox}
                        onClick={(selected) => this.handleClick(selected)}
                    />
                </span>
                <span className={styles.col2}>
                </span>
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        hideComputedCharges: bindActionCreators(noteActions.hideComputedCharges, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let computedChargesVisible = state.ui.notes[noteId].computedChargesVisible;

    return {
        computedChargesVisible
    };
}

const connectedPatientCareCenterNoteChargesGroupRow = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteChargesGroupRow);
export { connectedPatientCareCenterNoteChargesGroupRow as PatientCareCenterNoteChargesGroupRow };

